import Typography from '@mui/material/Typography';
import { Chip, ChipList, DayGroup, DayLabel, Root, TimeChip } from './styled';
import FeaturedAppointmentItemViewModel from './viewModel';
import { FeaturedScheduleDay } from '../../../../../services/availableTimes.service';

type Props = {
  featuredScheduleDays: FeaturedScheduleDay[];
};

export function FeaturedAppointmentItem({ featuredScheduleDays }: Props) {
  const { days, onSelectTime } = FeaturedAppointmentItemViewModel({ featuredScheduleDays });

  return (
    <Root>
      <Chip label={<Typography variant="body2B">Oportunidade!</Typography>} />
      {days.map(day => (
        <DayGroup key={day.date}>
          <DayLabel variant="body1B">{day.label}</DayLabel>
          <ChipList>
            {day.times.map(time => (
              <TimeChip
                key={time.time}
                label={time.label}
                variant="outlined"
                className={time.selected ? 'selected' : ''}
                onClick={() => onSelectTime(time.time)}
              />
            ))}
          </ChipList>
        </DayGroup>
      ))}
    </Root>
  );
}
